export default __webpack_public_path__ + "static/media/instagramIcon.bee726b0.svg";